import { InvoiceStatus } from "src/generated/graphqlTypes";
import { useRouteParams } from "src/hooks/useRouteParams";
import InvoiceCreatePage from "src/routes/projects/invoices/invoice-v2/InvoiceCreatePage";
import { IdOrAddParams, ProjectParams } from "src/routes/routesDef";
import { hasData, renderLoadingOrError } from "src/utils/queryResult";
import { InvoiceEditor } from "./InvoiceEditor";
import { useInvoicePageStatusQuery } from "./InvoicePage.generated";

/**
 * Entry point for the invoice page
 * If the invoice is a new one, it will be redirected to the stepper page
 * If the invoice is an existing one, it will be redirected to the editor page
 */
export function InvoicePage() {
  const { idOrAdd } = useRouteParams<ProjectParams & IdOrAddParams>();
  const isNew = idOrAdd === "add";

  const statusQuery = useInvoicePageStatusQuery({ variables: { invoiceId: idOrAdd! }, skip: isNew || !idOrAdd });
  // New invoices go straight to the stepper (no status to load yet).
  if (isNew) return <InvoiceCreatePage />;
  if (!hasData(statusQuery)) return renderLoadingOrError(statusQuery);

  const isDraft = statusQuery.data.invoice.status.code === InvoiceStatus.Draft;
  return isDraft ? <InvoiceCreatePage /> : <InvoiceEditor />;
}
